<svg xmlns="http://www.w3.org/2000/svg" width="79" height="217" viewBox="0 0 79 117" preserveAspectRatio="none">
  <defs>
    <linearGradient id="a" x1="0" x2="0" y1="0" y2="1">
      <stop offset="0%" stop-color="#E91E2E"/>
      <stop offset="100%" stop-color="#006BCD"/>
    </linearGradient>
  </defs>
  <g>
    <rect fill="url(#a)" x="0" y="0" width="79" height="117"/>
    <line stroke="#fff" stroke-linecap="square" stroke-width="1.82" x1="1" y1="116" x2="78" y2="1"/>
  </g>
</svg>
